import { DisplayModeEnum } from 'config/enums'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components/macro'
import Button from '../atoms/button'

const Container = styled.div`
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.sizings.lvl1};
`

const DisplayModeToggle = ({ displayMode, setDisplayMode, ...restProps }) => {
  const viewMode =
    displayMode === DisplayModeEnum.grid
      ? DisplayModeEnum.list
      : DisplayModeEnum.grid
  const icon =
    viewMode === DisplayModeEnum.grid
      ? 'display-mode-grid'
      : 'display-mode-list'

  return (
    <Container {...restProps}>
      <Button
        level="option"
        onClick={() => setDisplayMode(viewMode)}
        icon={icon}
        iconColor="actionsStandard"
      />
    </Container>
  )
}

DisplayModeToggle.propTypes = {
  className: PropTypes.string,
  displayMode: PropTypes.oneOf(Object.values(DisplayModeEnum)).isRequired,
  setDisplayMode: PropTypes.func.isRequired,
}

export default DisplayModeToggle
